import { h } from 'preact'
export const StarEmpty = () => {
    return (
    <svg class="icon icon-empty-star" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="WIP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Artboard" transform="translate(-793.000000, -263.000000)" fill="#BFBFBF">
                <polygon id="star-none" points="800.166667 273.472777 795.758277 276.567627 797.339388 271.418639 793.033743 268.182373 798.419312 268.094973 800.166667 263 801.914021 268.094973 807.299591 268.182373 802.993946 271.418639 804.575056 276.567627"></polygon> 
            </g>
        </g>
    </svg>
    )
}
